class Connection {
    constructor(messages, pkg, game, engine, user, config, react) {
        this.messages = messages;
        this.pkg = pkg;
        this.game = game;
        this.engine = engine;
        this.user = user;
        this.config = config;
        this.react = react;

        // 2026-06: REMOVIDO el `window.onbeforeunload` que cerraba el WS.
        // Bug reportado por zArko: si el user dispara el prompt del browser
        // (Ctrl+W, Ctrl+R, cerrar tab) y luego cancela, este handler YA se
        // ejecutó → ws cerrado → user queda en la página pero sin conexión.
        // Sin loss de funcionalidad real: si el user cierra la pestaña de
        // verdad, el TCP timeout (~30s con heartbeat) detecta el disconnect
        // server-side. Costo: cleanup 30s más lento. Beneficio: cero
        // conexiones perdidas por cancelar el prompt.
    }

    async startWebSocket() {
        // Antes de abrir el WS, fetcheamos un ticket HMAC-signed via REST.
        // El endpoint requiere session de Passport — si el user no está
        // logueado, devuelve 401 y el WS no se abre. El ticket vive 60s y
        // se pasa al WS en el URL `?t=<ticket>`. El servidor valida la
        // signature en el handshake. Mitiga CRIT-3 (impersonation via
        // forum + tokenAuth).
        //
        // apiBase: en dev local apuntamos al :3000 directo (browser y
        // express en host distinto del WS). En prod, /api es same-origin
        // y hereda el protocolo de la página — esto evita Mixed Content
        // cuando la página viene por HTTPS via Cloudflare tunnel.
        let ticket;
        try {
            const host =
                typeof window !== "undefined"
                    ? window.location.hostname
                    : "";
            const apiBase =
                host === "127.0.0.1" || host === "localhost"
                    ? "http://" + host + ":3000/api"
                    : "/api";
            const res = await fetch(apiBase + "/ws-ticket", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            if (!res.ok) {
                console.warn("[ws-ticket] HTTP " + res.status + " — abortando WS");
                this.react.setState({ showModalReconnect: false });
                return;
            }
            const body = await res.json();
            ticket = body && body.ticket;
            if (!ticket) {
                console.warn("[ws-ticket] response sin ticket — abortando WS");
                return;
            }
        } catch (err) {
            console.error("[ws-ticket] fetch falló:", err && err.message);
            // Reintentamos en 5s — la lógica de reconnect del onclose se
            // encarga si fuera necesario, pero esto cubre el caso inicial.
            setTimeout(() => this.startWebSocket(), 5000);
            return;
        }

        // Capturamos el WS en una local. Si una segunda invocación de
        // startWebSocket() ocurre antes de que la primera se conecte
        // (reconnect tras crash, HMR de Next.js, doble click en "Jugar"),
        // `this.config.ws` apunta a la NUEVA WS — pero el `onopen` de la
        // VIEJA sigue agendado. Sin la check de abajo, ese onopen viejo
        // dispara `send()` sobre la nueva WS que todavía está CONNECTING
        // → "InvalidStateError: Still in CONNECTING state".
        const endpoint = this.config.debug
            ? this.config.LOCAL_SERVER_ENDPOINT
            : this.config.PROD_SERVER_ENDPOINT;
        const ws = new WebSocket(endpoint + "?t=" + encodeURIComponent(ticket));

        this.config.ws = ws;
        ws.binaryType = "arraybuffer";

        // Tracking del interval de ping para limpiarlo en cada reconnect
        // (sino quedan zombies acumulándose en sesiones largas).
        if (this._pingInterval) {
            clearInterval(this._pingInterval);
            this._pingInterval = null;
        }

        ws.onopen = () => {
            // Stale check: si ya fuimos reemplazados por otra conexión,
            // no hacemos nada. La nueva WS dispara su propio onopen.
            if (this.config.ws !== ws) return;

            this.react.setState({
                showModalReconnect: false
            });

            console.log("Conecto Web Socket");
            this.game.connectCharacter();

            this._pingInterval = setInterval(() => {
                if (this.user.id && this.config.ws === ws && ws.readyState === WebSocket.OPEN) {
                    this.config.pingStart = +Date.now();

                    this.pkg.setPackageID(this.pkg.serverPacketID.ping);
                    ws.send(this.pkg.dataSend());
                }
            }, 10000);
        };

        this.config.ws.onclose = () => {
            this.engine.deleteAllPersonajes();
            this.config.usersOnline = 0;
            this.config.dialogs = {};
            this.user.id = 0;
            this.user.pos.x = 0;
            this.user.pos.y = 0;
            this.engine.ping = 0;
            this.config.items = {};
            this.config.spells = {};
            this.config.seguroActivado = true;

            this.items = {};
            this.spells = {};

            this.react.setState({
                user: this.user,
                messagesConsole: []
            });

            this.engine.clearRender("items");
            this.engine.clearRender("background");
            this.engine.clearRender("techos");
            this.engine.clearRender("foreground");
            this.engine.clearRender("textos");

            if (!this.config.varCloseForce) {
                this.react.setState({
                    showModalReconnect: true
                });

                setTimeout(() => {
                    if (this.config.debug) {
                        this.startWebSocket();
                    } else {
                        this.startWebSocket();
                    }
                }, 5000);
            }
        };

        this.config.ws.onerror = err => {
            console.log("WebSocket Error ");
            console.log(err);
        };

        this.config.ws.onmessage = this.messages.connectionMessages;
    }
}

export default Connection;

// export function cleanMap() {
//     for (numMap = 1; numMap <= 290; numMap++) {
//         engine.cleanMapData(numMap);
//     }

//     console.log("borro todo");
// }
